//--------------------------------------------------
// imported classes
//--------------------------------------------------
const ObjectFunc = require('../../util/ObjectFunc')
const Common = require('../to/Common')

const common = new Common

/**
 * The Organization class acts as the view object for the organization.
 */
const tbs_model_vo_Organization = function() {
}

//--------------------------------------------------
// prototype
//--------------------------------------------------
tbs_model_vo_Organization.prototype = {
    /* The view object name */
    name: 'organization',
    /* The view object instance */
    view: {
        query: {
            baseUrl: process.env.VUE_APP_BANMA_API,
            apiPrefix: '/bmmatch/',
            service: 'getMyMatchOrganizationList',
            basePath: 'data.list',
            rule: {
                id: '~id',
                name: 'name',
                logoUrl: 'logo',
                area: '$country,province,city,district',
                areaId: '$countryId,provinceId,cityId,districtId',
                contact: 'contact',
                position: 'role'
            }
        },
        prefetch: {
            method: 'get',
            baseUrl: process.env.VUE_APP_BANMA_API,
            apiPrefix: '/bmmatch/',
            service: 'GetAreaTreeList',
            basePath: 'data.list',
            rule: {
                areaList: '$list',
                areaIdList: '$list',
                sportTypeOptions: '$list',
            }
        },
        fetch: [
            {
                method: 'get',
                baseUrl: process.env.VUE_APP_BANMA_API,
                apiPrefix: '/bmmatch/',
                service: 'GetAreaTreeList',
                query: {
                },
                basePath: 'data.list',
                rule: {
                    areaList: '$list',
                    areaIdList: '$list',
                    sportTypeOptions: '$list',
                }
            },
            {
                method: 'get',
                baseUrl: process.env.VUE_APP_BANMA_API,
                apiPrefix: '/bmmatch/',
                service: 'GetCrmAccount2',
                query: {
                    id: 'id',
                },
                basePath: 'data.account',
                rule: {
                    id: '~id',
                    name: 'name',
                    logoUrl: 'logo',
                    area: '$country,province,city,district',
                    areaId: '$countryId,provinceId,cityId,districtId',
                    contact: 'contact',
                    position: 'role',
                    sportTypeList: '$sportValueArray'
                }
            },
            {
                method: 'get',
                baseUrl: process.env.VUE_APP_BANMA_API,
                apiPrefix: '/bmmatch/',
                service: 'GetCrmAccountMyManagerRole',
                query: {
                    accountId: 'id'
                },
                basePath: 'data',
                rule: {
                    isOwner: '@isLinkman',
                }
            },
        ],
        get: {
            baseUrl: process.env.VUE_APP_BANMA_API,
            apiPrefix: '/bmmatch/',
            service: 'GetCrmAccount2',
            basePath: 'data.account',
            rule: {
                id: '~id',
                name: 'name',
                logoUrl: 'logo',
                area: '$country,province,city,district',
                areaId: '$countryId,provinceId,cityId,districtId',
                contact: 'contact',
                position: 'role',
                sportTypesLabel: '$sportValueArray'
            }
        },
        create: {
            baseUrl: process.env.VUE_APP_BANMA_API,
            apiPrefix: '/bmmatch/',
            service: 'CreateCrmAccount2',
            basePath: '',
            rule: {
                name: 'name',
                logo: 'logo',
                areaId: 'areaId',
                area: 'area',
                contact: 'contact',
                role: 'position',
                sportValueArray: '$sportTypeList'
            }
        },
        update: {
            baseUrl: process.env.VUE_APP_BANMA_API,
            apiPrefix: '/bmmatch/',
            service: 'UpdateCrmAccount2',
            basePath: '',
            rule: {
                id: 'id',
                name: 'name',
                logo: 'logo',
                areaId: 'areaId',
                area: 'area',
                contact: 'contact',
                role: 'position',
                sportValueArray: '$sportTypeList'
            }
        },
        remove: {
            baseUrl: process.env.VUE_APP_BANMA_API,
            apiPrefix: '/bmmatch/',
            service: 'DeleteCrmAccount2',
            basePath: '',
            rule: {
                id: 'id'
            }
        },
    },
    //--------------------------------------------------
    // private method
    //--------------------------------------------------
    renderSportTypesLabel: function(sportValueArray) {
        return sportValueArray.replaceAll(',', common.localeProp('comma'))
    },
    renderSportTypeList: function(sportValueArray) {
        const sportTypeList = []
        const sportValues = sportValueArray.split(',')
        for (let i = 1; i < 12; i++) {
            for (let j = 0; j < sportValues.length; j++) {
                if (sportValues[j] === common.localeProp('sport-type-' + i)) {
                    sportTypeList.push(i.toString())
                }
            }
        }
        // console.log('renderSportTypeList', sportTypeList)
        return sportTypeList
    },
    formatSportValueArray: function(sportTypeList) {
        let sportTypeArray = []
        for (let i = 0; i < sportTypeList.length; i++) {
            let sportType = sportTypeList[i]
            sportTypeArray.push(common.localeProp('sport-type-' + sportType))
        }
        return sportTypeArray.join(',')
    },
    renderSportTypeOptions: function() {
        const sportTypeOptions = []
        for (let i = 1; i < 12; i++) {
            sportTypeOptions.push({
                value: i.toString(),
                label: common.localeProp('sport-type-' + i),
            })
        }
        return sportTypeOptions
    },
    renderAreaList: function(list) {
        const areaList = {
            province_list: {},
            city_list: {},
            county_list: {}
        }
        // console.log('list', list)
        const treeList = JSON.parse(list.replaceAll("'", '"')) || [];
        // console.log('treeList', treeList)
        let provinceItem, cityItem, countyItem
        let key
        for (let i = 0; i < treeList.length; i++) {
            provinceItem = treeList[i]
            key = i + 11 + '0000'
            areaList.province_list[key] = provinceItem.name
            if (provinceItem.kids) {
                for (let j = 0; j < provinceItem.kids.length; j++) {
                    cityItem = provinceItem.kids[j]
                    key = i + 11 + ObjectFunc.pad(j+1, 2) + '00'
                    areaList.city_list[key] = cityItem.name
                    if (cityItem.kids) {
                        for (let k = 0; k < cityItem.kids.length; k++) {
                            countyItem = cityItem.kids[k]
                            key = i + 11 + ObjectFunc.pad(j+1, 2) + ObjectFunc.pad(k+1, 2)
                            areaList.county_list[key] = countyItem.name
                        }
                    }
                }
            }
        }
        return areaList
    },
    renderAreaIdList: function(list) {
        const areaIdList = {
            province_list: {},
            city_list: {},
            county_list: {}
        }
        // console.log('list', list)
        const treeList = JSON.parse(list.replaceAll("'", '"')) || [];
        // console.log('treeList', treeList)
        let provinceItem, cityItem, countyItem
        let key
        for (let i = 0; i < treeList.length; i++) {
            provinceItem = treeList[i]
            key = i + 11 + '0000'
            areaIdList.province_list[key] = provinceItem.id
            if (provinceItem.kids) {
                for (let j = 0; j < provinceItem.kids.length; j++) {
                    cityItem = provinceItem.kids[j]
                    key = i + 11 + ObjectFunc.pad(j+1, 2) + '00'
                    areaIdList.city_list[key] = cityItem.id
                    if (cityItem.kids) {
                        for (let k = 0; k < cityItem.kids.length; k++) {
                            countyItem = cityItem.kids[k]
                            key = i + 11 + ObjectFunc.pad(j+1, 2) + ObjectFunc.pad(k+1, 2)
                            areaIdList.county_list[key] = countyItem.id
                        }
                    }
                }
            }
        }
        return areaIdList
    },
    renderArea: function(country, province, city, district) {
        let area = ''
        if (country && !province) {
            area = country
        }
        else {
            area = province
        }
        if (city) {
            area += ' ' + city
        }
        if (district) {
            area += ' ' + district
        }
        return area
    },
    renderAreaId: function(countryId, provinceId, cityId, districtId) {
        let areaId = countryId
        if (provinceId) {
            areaId = provinceId
        }
        if (cityId) {
            areaId = cityId
        }
        if (districtId) {
            areaId = districtId
        }
        return areaId
    },
}

module.exports = tbs_model_vo_Organization